import starsJson from "./stars.json";

export const stars = starsJson.stars.sort(
  (starA, starB) => starA.radius - starB.radius
);
